import React, { useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { bulkDeleteBatchImage } from '../../api/batchImage';

const BulkDeleteImageModal = ({
  modalOpenState,
  closeModalHandler,
  batch,
  date,
  imageIds,
  fetchNewData
}) => {
  const [successAlert, setSuccessAlert] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);

  const deleteImages = async () => {
    setRequestLoading(true);
    const response = await bulkDeleteBatchImage(batch, date, imageIds);
    if (response) {
      setRequestLoading(false);
      setSuccessAlert('Images deleted successfully');
      closeModalHandler();
      fetchNewData();
    }
  };

  return (
    <React.Fragment>
      {successAlert && (
        <SweetAlert
          success
          title="Deleted"
          onConfirm={() => setSuccessAlert(false)}
        >
          {successAlert}
        </SweetAlert>
      )}
      <Modal isOpen={modalOpenState} backdrop="static" size="md">
        <ModalHeader toggle={closeModalHandler}></ModalHeader>
        <ModalBody>
          <h4>Are you sure you want to delete these images?</h4>
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={requestLoading}
            type="button"
            color="light"
            onClick={closeModalHandler}
          >
            Close
          </Button>
          <Button type="submit" color="danger" onClick={() => deleteImages()}>
            {requestLoading ? 'Deleting ...' : 'Delete'}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default BulkDeleteImageModal;
